import React, { Component } from 'react'
import Style from './style.module.less'
import Tabs from './tabs'
import Store from './store'
import { observer, Provider } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    const {
      location: {
        query: { key }
      }
    } = this.props

    this.store = new Store(key)
  }

  componentDidMount() {
    this.store.getUnAuditNumber()
  }

  render() {
    return (
      <Provider store={this.store}>
        <HeaderView
          contentStyle={{ padding: '0 20px' }}
          className={Style.sitebox}
        >
          <Tabs />
        </HeaderView>
      </Provider>
    )
  }
}
